@if (data.productDescription) {
  <ion-content>
    <div class="content-page" [innerHTML]="data.productDescription"></div>
    <ion-row>
      <h1 class="back-text link-text-blue" (click)="closeBottomSheet()">&larr; {{"store-product.Back" | translate}}</h1>
    </ion-row>
  </ion-content>
}
